import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { ArrowIcon, Text } from '@beef/ui-kit';
import { Flag } from "../Flag";
import style from "./styles.module.pcss";
var cn = classNames.bind(style);
export var Country = /*#__PURE__*/memo(function (_ref) {
  var srcIcon = _ref.srcIcon,
    lang = _ref.lang,
    isActive = _ref.isActive,
    link = _ref.link,
    isTargetBlank = _ref.isTargetBlank;
  var ComponentContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('flex')
  }, /*#__PURE__*/React.createElement(Flag, {
    classname: cn('flag'),
    srcIcon: srcIcon
  }), /*#__PURE__*/React.createElement(Text, {
    size: "size4-r"
  }, lang)), isTargetBlank && /*#__PURE__*/React.createElement("div", {
    className: cn('arrow-pointer', 'flex')
  }, /*#__PURE__*/React.createElement(ArrowIcon, null)));
  if (isActive) {
    return /*#__PURE__*/React.createElement("div", {
      className: cn('country', {
        'country--active': isActive
      })
    }, ComponentContent);
  }
  return /*#__PURE__*/React.createElement("a", {
    className: cn('country', {
      'country--active': isActive
    }),
    href: link
  }, ComponentContent);
});